module.exports = __webpack_public_path__ + "static/media/6.0e816b7f.mp4";